import { createSlice, createAction } from '@reduxjs/toolkit';
import {
  fetchImageRequests,
  updateImageRequest,
  removeImageRequest,
} from '../actions/imageRequests-actions';

export const setSearchParams = createAction('imageRequests/setSearchParams');

const initialState = {
  isLoading: true,
  items: [],
  count: 0,
  searchParams: {},
  currentPage: 1,
  perPage: 10,
};

const imageRequestsSlice = createSlice({
  name: 'imageRequests',
  initialState,
  reducers: {
    patchItem(state, action) {
      const { id, changes } = action.payload || {};
      if (!id) return;
      const idx = state.items.findIndex((it) => (it.id || it._id) === id);
      if (idx !== -1) {
        state.items[idx] = { ...state.items[idx], ...changes };
      }
    },
    setCurrentPage(state, action) {
      state.currentPage = action.payload || 1;
    },
    setPerPage(state, action) {
      state.perPage = action.payload || 10;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchImageRequests.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchImageRequests.fulfilled, (state, action) => {
        const { imageRequests, count } = action.payload || {};
        state.items = imageRequests || [];
        state.count = count || 0;
        state.isLoading = false;
      })
      .addCase(fetchImageRequests.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(updateImageRequest.fulfilled, (state, action) => {
        const updated = action.payload;
        if (!updated) return;
        const id = updated.id || updated._id;
        const idx = state.items.findIndex((it) => (it.id || it._id) === id);
        if (idx !== -1) {
          state.items[idx] = { ...state.items[idx], ...updated };
        }
      })
      .addCase(removeImageRequest.fulfilled, (state, action) => {
        const id = action.payload;
        state.items = state.items.filter((it) => (it.id || it._id) !== id);
        if (state.count > 0) state.count -= 1;
      })
      .addCase(setSearchParams, (state, action) => {
        state.searchParams = action.payload || {};
      });
  },
});

export const imageRequestsActions = {
  ...imageRequestsSlice.actions,
  setSearchParams,
};

export default imageRequestsSlice;
